(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["letimore-header-overlay"]) return;
  try {
    
  const setupLetimoreStickyHeader = () => {
    if (window.letimoreStickyHeaderBound) return;

    window.letimoreStickyHeaderBound = true;

    const header = document.querySelector('#header-component');
    const pageWrapper = document.querySelector('.page-wrapper');
    let frame;

    const updateStickyHeader = () => {
      if (!header) return;

      const scrollTop = Math.max(window.scrollY, pageWrapper?.scrollTop || 0);
      header.dataset.stickyState = scrollTop > 8 ? 'active' : 'inactive';
    };

    const requestStickyHeaderUpdate = () => {
      if (frame) return;

      frame = requestAnimationFrame(() => {
        frame = undefined;
        updateStickyHeader();
      });
    };

    window.addEventListener('scroll', requestStickyHeaderUpdate, { passive: true });
    pageWrapper?.addEventListener('scroll', requestStickyHeaderUpdate, { passive: true });
    updateStickyHeader();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupLetimoreStickyHeader, { once: true });
  } else {
    setupLetimoreStickyHeader();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["letimore-review-anchor"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const target = document.getElementById('looxReviews');
    if (!target) return;

    const jumpToReviews = () => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history?.replaceState) {
        window.history.replaceState(null, '', '#looxReviews');
      }
    };

    const bindRatingLinks = () => {
      document
        .querySelectorAll(".product-information .rating-wrapper")
        .forEach((rating) => {
          if (rating.dataset.reviewJumpBound === 'true') return;
          rating.dataset.reviewJumpBound = 'true';
          rating.setAttribute('role', 'link');
          rating.setAttribute('tabindex', '0');
          rating.setAttribute('aria-label', 'Read customer reviews');
          rating.addEventListener('click', jumpToReviews);
          rating.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              jumpToReviews();
            }
          });
        });
    };

    const addTrustBadges = () => {
      const host = document.querySelector('.product-information .buy-buttons-block');
      if (!host || host.parentElement?.querySelector(':scope > .letimore-trust-badges')) return;

      const badges = document.createElement('div');
      badges.className = 'letimore-trust-badges';
      badges.setAttribute('aria-label', 'Shopping guarantees');
      badges.innerHTML = `
        <div class="letimore-trust-badge">
          <svg class="letimore-trust-badge__icon" aria-hidden="true" viewBox="0 0 32 32" fill="none">
            <path d="M3.5 8.5h15v13h-15zM18.5 13h5.3l4.7 5v3.5h-10zM8.5 25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM23.5 25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
          </svg>
          <span class="letimore-trust-badge__title">Free Shipping</span>
          <span class="letimore-trust-badge__subtitle">Orders over $69.99<br>Delivery in 5–8 Business Days</span>
        </div>
        <div class="letimore-trust-badge">
          <svg class="letimore-trust-badge__icon" aria-hidden="true" viewBox="0 0 32 32" fill="none">
            <path d="M25.5 11A11 11 0 1 0 27 18M25.5 11V4.5M25.5 11H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="letimore-trust-badge__title">30-Day Returns</span>
          <span class="letimore-trust-badge__subtitle">Money-Back Guarantee</span>
        </div>
        <div class="letimore-trust-badge">
          <svg class="letimore-trust-badge__icon" aria-hidden="true" viewBox="0 0 32 32" fill="none">
            <rect x="6" y="13" width="20" height="15" rx="2" stroke="currentColor" stroke-width="1.8"/>
            <path d="M10.5 13V9.5a5.5 5.5 0 0 1 11 0V13M16 19v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          <span class="letimore-trust-badge__title">Secure Checkout</span>
          <span class="letimore-trust-badge__subtitle">Protected Payment</span>
        </div>
        <div class="letimore-trust-badge">
          <svg class="letimore-trust-badge__icon" aria-hidden="true" viewBox="0 0 32 32" fill="none">
            <path d="m5 10 11-6 11 6-11 6-11-6ZM5 10v12l11 6 11-6V10M16 16v12" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
            <path d="m11 7 11 6" stroke="currentColor" stroke-width="1.8"/>
          </svg>
          <span class="letimore-trust-badge__title">In Stock</span>
          <span class="letimore-trust-badge__subtitle letimore-trust-badge__subtitle--accent">Limited Offer</span>
        </div>
      `;

      host.insertAdjacentElement('afterend', badges);
    };

    const isReviewFormOpen = () => {
      const expandedButton = document.querySelector(
        '#judgeme_product_reviews .jdgm-write-rev-link[aria-expanded="true"]'
      );
      if (expandedButton) return true;

      const form = document.querySelector('#judgeme_product_reviews .jdgm-form-wrapper');
      if (!form) return false;
      const styles = window.getComputedStyle(form);
      return (
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        form.getBoundingClientRect().height > 0
      );
    };

    const bindWriteReviewFirstClick = () => {
      document
        .querySelectorAll('#judgeme_product_reviews .jdgm-write-rev-link')
        .forEach((button) => {
          if (button.dataset.letimoreFirstClickBound === 'true') return;
          button.dataset.letimoreFirstClickBound = 'true';

          button.addEventListener('click', () => {
            if (button.dataset.letimoreRetryClick === 'true') {
              delete button.dataset.letimoreRetryClick;
              return;
            }

            window.setTimeout(() => {
              if (isReviewFormOpen()) return;

              const activeButton =
                (button.isConnected && button) ||
                document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');
              if (!activeButton) return;

              activeButton.dataset.letimoreRetryClick = 'true';
              activeButton.click();
            }, 180);
          });
        });
    };

    let allReviewsLoadTimer;

    const reviewPageSignature = (reviews) =>
      Array.from(reviews.querySelectorAll(':scope > .jdgm-rev'))
        .map((review) => review.dataset.reviewId || review.id || review.textContent.trim().slice(0, 80))
        .join('|');

    const collectReviewCards = (reviews, cards) => {
      reviews.querySelectorAll(':scope > .jdgm-rev').forEach((review, index) => {
        const key =
          review.dataset.reviewId ||
          review.id ||
          review.querySelector('.jdgm-rev__author')?.textContent?.trim() + '|' +
            review.querySelector('.jdgm-rev__body')?.textContent?.trim() ||
          'review-' + cards.size + '-' + index;
        if (!cards.has(key)) cards.set(key, review.cloneNode(true));
      });
    };

    const liveReviewsContainer = (widget) =>
      widget.querySelector('.jdgm-rev-widg__reviews');

    const waitForReviewPageChange = (widget, before, timeoutMs = 12000) =>
      new Promise((resolve) => {
        let settled = false;
        let stabilityTimer;
        const finish = (changed) => {
          if (settled) return;
          settled = true;
          observer.disconnect();
          window.clearTimeout(timeout);
          window.clearTimeout(stabilityTimer);
          resolve(changed);
        };
        const check = () => {
          const liveReviews = liveReviewsContainer(widget);
          if (!liveReviews) return;
          const hasCards = liveReviews.querySelectorAll(':scope > .jdgm-rev').length > 0;
          const changed = reviewPageSignature(liveReviews) !== before;
          if (!hasCards || !changed) return;
          window.clearTimeout(stabilityTimer);
          stabilityTimer = window.setTimeout(() => {
            const latest = liveReviewsContainer(widget);
            const ready =
              latest &&
              latest.querySelectorAll(':scope > .jdgm-rev').length > 0 &&
              reviewPageSignature(latest) !== before;
            finish(Boolean(ready));
          }, 700);
        };
        const observer = new MutationObserver(check);
        observer.observe(widget, { childList: true, subtree: true });
        const timeout = window.setTimeout(() => finish(false), timeoutMs);
        check();
      });

    const clickReviewPage = async (widget, pageNumber) => {
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const pagination = widget.querySelector('.jdgm-paginate');
        const reviews = liveReviewsContainer(widget);
        if (!pagination || !reviews) return false;
        const links = Array.from(
          pagination.querySelectorAll('.jdgm-paginate__page[data-page="' + pageNumber + '"]')
        );
        const link =
          links.find((item) => item.textContent.trim() === String(pageNumber)) ||
          links.find((item) => !item.classList.contains('jdgm-curt')) ||
          links[0];
        if (!link) return false;
        const before = reviewPageSignature(reviews);
        const changed = waitForReviewPageChange(widget, before);
        link.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }));
        if (await changed) return true;
        await new Promise((resolve) => window.setTimeout(resolve, 1000));
      }
      return false;
    };

    const loadAllReviewsOnOnePage = async () => {
      const widget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      const reviews = widget?.querySelector('.jdgm-rev-widg__reviews');
      const pagination = widget?.querySelector('.jdgm-paginate');
      if (!widget || !reviews || !pagination) return;
      if (
        widget.dataset.letimoreAllReviewsLoading === 'true' ||
        widget.dataset.letimoreAllReviewsComplete === 'true'
      ) return;

      const expectedReviews = Number.parseInt(widget.dataset.numberOfReviews || '0', 10);
      const visibleReviews = reviews.querySelectorAll(':scope > .jdgm-rev').length;
      if (expectedReviews > 0 && visibleReviews >= expectedReviews) {
        pagination.style.display = 'none';
        widget.dataset.letimoreAllReviewsComplete = 'true';
        return;
      }

      const pageNumbers = Array.from(
        pagination.querySelectorAll('.jdgm-paginate__page[data-page]')
      )
        .map((link) => Number.parseInt(link.dataset.page || '0', 10))
        .filter((page) => Number.isFinite(page) && page > 0);
      const lastPage = Math.max(1, ...pageNumbers);
      if (lastPage < 2) return;

      widget.dataset.letimoreAllReviewsLoading = 'true';
      const cards = new Map();
      collectReviewCards(reviews, cards);

      const currentPage = Number.parseInt(
        pagination.querySelector('.jdgm-paginate__page.jdgm-curt')?.dataset.page || '1',
        10
      );
      const pagesToLoad = Array.from(new Set(pageNumbers))
        .sort((a, b) => a - b)
        .filter((page) => page !== currentPage);

      let succeeded = true;
                  const scrollWidget = widget.closest('.jdgm-widget') || widget;      const widgetData = window.jdgm?.$?.(scrollWidget);
                  const originalFocusFirstPaginatedItem = window.jdgm?._focusFirstPaginatedItem;
                              scrollWidget.setAttribute('data-not-scroll-to', 'true');
                              widgetData?.data('not-scroll-to', true);
                                    if (typeof originalFocusFirstPaginatedItem === 'function') {
                                            window.jdgm._focusFirstPaginatedItem = () => {};
                                                  }
      for (const page of pagesToLoad) {
        const loaded = await clickReviewPage(widget, page);
        if (!loaded) {
          succeeded = false;
          break;
        }
        const loadedReviews = liveReviewsContainer(widget);
        if (loadedReviews) collectReviewCards(loadedReviews, cards);
      }

                        scrollWidget.removeAttribute('data-not-scroll-to');
                        widgetData?.removeData('not-scroll-to');
                              if (typeof originalFocusFirstPaginatedItem === 'function') {
                                      window.jdgm._focusFirstPaginatedItem = originalFocusFirstPaginatedItem;
                                            }

                                                  const finalReviews = liveReviewsContainer(widget);
      const finalPagination = widget.querySelector('.jdgm-paginate');
      if (succeeded && finalReviews && cards.size > visibleReviews) {
        finalReviews.replaceChildren(...Array.from(cards.values()));
        if (finalPagination) finalPagination.style.display = 'none';
        widget.dataset.letimoreAllReviewsComplete = 'true';
        widget.dataset.letimoreLoadedReviewCount = String(cards.size);
        addAvatarChecks(finalReviews);
        loadReviewImages(finalReviews);
      }

      delete widget.dataset.letimoreAllReviewsLoading;

      if (!succeeded) {
        const retries = Number.parseInt(widget.dataset.letimoreAllReviewsRetries || '0', 10);
        if (retries < 2) {
          widget.dataset.letimoreAllReviewsRetries = String(retries + 1);
          window.setTimeout(scheduleAllReviewsLoad, 1600);
        }
      }
    };

    const scheduleAllReviewsLoad = () => {
      const widget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      if (
        widget?.dataset.letimoreAllReviewsLoading === 'true' ||
        widget?.dataset.letimoreAllReviewsComplete === 'true'
      ) return;
      window.clearTimeout(allReviewsLoadTimer);
      allReviewsLoadTimer = window.setTimeout(loadAllReviewsOnOnePage, 2200);
    };

    const bindReviewSortReload = () => {
      const widget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      const sort = widget?.querySelector('.jdgm-sort-dropdown');
      if (!widget || !sort || sort.dataset.letimoreReloadBound === 'true') return;
      sort.dataset.letimoreReloadBound = 'true';
      sort.addEventListener('change', () => {
        delete widget.dataset.letimoreAllReviewsComplete;
        delete widget.dataset.letimoreAllReviewsRetries;
        window.setTimeout(scheduleAllReviewsLoad, 1800);
      });
    };

    const prepareReviewImage = (image) => {
      if (!(image instanceof HTMLImageElement)) return;
      const link = image.closest('.jdgm-rev__pic-link');
      const finish = () => {
        link?.classList.remove('jdgm--loading');
        image.removeAttribute('aria-busy');
      };

      if (image.dataset.letimoreImageBound !== 'true') {
        image.dataset.letimoreImageBound = 'true';
        image.setAttribute('aria-busy', 'true');

        image.addEventListener('load', finish);
        image.addEventListener('error', () => {
          if (image.dataset.originalRetried === 'true') {
            finish();
            return;
          }

          image.dataset.originalRetried = 'true';
          try {
            const fallback = new URL(link?.href || image.dataset.src, window.location.href);
            fallback.search = '';
            image.src = fallback.toString();
          } catch (error) {
            finish();
          }
        });
      }

      if (!image.getAttribute('src') && image.dataset.src) {
        image.src = image.dataset.src;
      }

      if (image.complete && image.naturalWidth > 0) {
        finish();
      } else {
        link?.classList.remove('jdgm--loading');
      }
    };

    const addAvatarChecks = (root = document) => {
      const icons = [];
      if (root.matches?.('#judgeme_product_reviews .jdgm-rev__icon')) {
        icons.push(root);
      }
      root
        .querySelectorAll?.('#judgeme_product_reviews .jdgm-rev__icon')
        .forEach((icon) => icons.push(icon));

      icons.forEach((icon) => {
        if (icon.querySelector('.letimore-avatar-check')) return;
        const check = document.createElement('span');
        check.className = 'letimore-avatar-check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        icon.appendChild(check);
      });
    };

    const loadReviewImages = (root = document) => {
      if (root.matches?.('.jdgm-rev__pic-img')) {
        prepareReviewImage(root);
      }
      root
        .querySelectorAll?.('.jdgm-rev__pic-img')
        .forEach(prepareReviewImage);
    };

    bindRatingLinks();
    bindWriteReviewFirstClick();
    bindReviewSortReload();
    scheduleAllReviewsLoad();
    addAvatarChecks();
    addTrustBadges();
    loadReviewImages();

    const observer = new MutationObserver((mutations) => {
      bindRatingLinks();
        addAvatarChecks();
      addTrustBadges();
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          loadReviewImages(node);
        });
      });
    });

    observer.observe(document.getElementById('MainContent'), {
      childList: true,
      subtree: true,
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('LetimoreWelcomePopup');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const storageKey = 'letimore_welcome_popup_dismissed';
    const closeButton = dialog.querySelector('[data-popup-close]');
    const image = dialog.querySelector('[data-src]');
    const success = dialog.querySelector('[data-popup-success]');
    const delay = Number(dialog.dataset.delay || 2500);
    const dismissDays = Number(dialog.dataset.dismissDays || 7);

    const remember = (days) => {
      try {
        localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
      } catch (error) {
        return;
      }
    };

    const close = () => {
      remember(dismissDays);
      dialog.close();
    };

    const wasDismissed = () => {
      try {
        return Number(localStorage.getItem(storageKey) || 0) > Date.now();
      } catch (error) {
        return false;
      }
    };

    closeButton?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });

    if (success) {
      remember(365);
      if (image?.dataset.src) image.src = image.dataset.src;
      dialog.showModal();
      success.focus();
      return;
    }

    const designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !wasDismissed()) {
      window.setTimeout(() => {
        if (image?.dataset.src) image.src = image.dataset.src;
        dialog.showModal();
      }, designMode ? 300 : delay);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
